// frontend/klaes-app/src/components/FilmFavs/components/BatteryIndicator.jsx
import { getBatteryLevel } from '../utils/helpers';
import styles from '../FilmFavs.module.css';

export const BatteryIndicator = ({ rating, onClick, isUserRating = false, pulsate = false }) => {
  // Stelle sicher, dass rating eine Zahl ist
  const numericRating = typeof rating === 'number' ? rating : parseFloat(rating) || 0;
  const { level, color } = getBatteryLevel(numericRating);

  return (
    <div 
      className={`${styles.battery} ${isUserRating ? styles.userBattery : ''} ${pulsate ? styles.pulsate : ''}`} 
      onClick={onClick}
    >
      <div className={styles.batteryContainer}>
        {[...Array(5)].map((_, i) => (
          <div 
            key={i} 
            className={`${styles.batteryCell} ${i < level ? styles[`${color}Filled`] : styles.empty}`}
          />
        ))}
        <div className={styles.batteryCap} />
      </div>
      <span className={styles.batteryRating}>{numericRating.toFixed(1)}%</span>
    </div>
  );
};